module.exports = __webpack_public_path__ + "img/undraw_task_list_6x9d.dbd90765.svg";